<template>
  <!-- Componente: muestra {v1} / {v2} y debajo el ESTADO, centrado y sin badges -->
  <div class="estado-ratio">
    <div class="ratio" :class="estadoClase">
      <span class="v1">{{ v1 }}</span>
      <span class="sep"> / </span>
      <span class="v2">{{ v2 }}</span>
    </div>
    <div class="estado" :class="estadoClase">{{ estado }}</div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { inventario_estados } from '@/utilities/global-constants'

export default defineComponent({
  name: 'InventarioEstadoRatio',
  props: {
    // valores del ratio mostrado arriba del estado
    v1: { type: [Number, String], required: true },
    v2: { type: [Number, String], required: true },
    // texto del estado (LISTO, REABIERTO / PENDIENTES, Aprobado, CERRADO)
    estado: { type: String, required: true }
  },
  computed: {
    // color del texto del estado según su tipo
    estadoClase () {
      const e = (this.estado || '').toLowerCase()
      if (e === inventario_estados.aprobado.texto.toLowerCase()) return 'exito'
      if (e === inventario_estados.reabierto.texto.toLowerCase()) return 'aviso'
      if (e === inventario_estados.cerrado.texto.toLowerCase()) return 'fracaso'
      return 'oscuro'
    }
  }
})
</script>

<style scoped>
.estado-ratio { display: flex; flex-direction: column; align-items: center; justify-content: center; }
.ratio { font-weight: bold; font-size: 1rem; }
.estado { font-size: 0.9rem; }
.oscuro { color: var(--ion-color-medium); }
.aviso { color: var(--ion-color-warning); }
.exito { color: var(--ion-color-success); }
.fracaso { color: var(--ion-color-danger); }
</style>
